import React, { SetStateAction } from "react";
import { Property } from "../../types/Property";
import MortgageApplication from "./_index";

const Mortgage = ({
  propertyId,
  price,
  setMortgageSuccess,
  property,
}: {
  propertyId: number | undefined;
  price: number | undefined;
  setMortgageSuccess: React.Dispatch<SetStateAction<boolean>>;
  property: Property | undefined;
}) => {
  return (
    <MortgageApplication
      propertyId={propertyId}
      price={price}
      setMortgageSuccess={setMortgageSuccess}
      property={property}
    />
  );
};

export default Mortgage;
